import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useForm } from "react-hook-form"
import Input from "../../atoms/input/input"
import Select from "../../atoms/select/select"
import Button from "../../atoms/button/button"
import DataPolicy from "../../atoms/data-policy/data-policy"
import { siteUrl } from "../../../utils/siteUrl"
import "./select-birthdate.scss"
import useDataPolicy from "../../../hooks/useDataPolicy"

const SelectBirthday = ({ onSubmit, closeModal }) => {
  const { register, handleSubmit, errors } = useForm()

  const { checksPolicy } = useDataPolicy()

  const queryResult = useStaticQuery(graphql`
    query TYC_STEPS_QUERY {
      allContentfulNolFooter {
        nodes {
          node_locale
          redireccionPoliticaPrivacidadDatos
          redireccionTerminosYCondiciones
        }
      }
    }
  `)

  const {
    redireccionPoliticaPrivacidadDatos,
    redireccionTerminosYCondiciones,
  } = queryResult.allContentfulNolFooter.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0]

  const months = [
    {
      month: "Enero",
      number: 1,
    },
    {
      month: "Febrero",
      number: 2,
    },
    {
      month: "Marzo",
      number: 3,
    },
    {
      month: "Abril",
      number: 4,
    },
    {
      month: "Mayo",
      number: 5,
    },
    {
      month: "Junio",
      number: 6,
    },
    {
      month: "Julio",
      number: 7,
    },
    {
      month: "Agosto",
      number: 8,
    },
    {
      month: "Septiembre",
      number: 9,
    },
    {
      month: "Octubre",
      number: 10,
    },
    {
      month: "Noviembre",
      number: 11,
    },
    {
      month: "Diciembre",
      number: 12,
    },
  ]

  return (
    <div className="f-select-birthdate">
      <h3 className="f-title-modal">
        ¿Quieres cambiar tu fecha de nacimiento?
      </h3>
      <h4 className="f-select-birthdate__subtitle">
        ¿Cuál es tu fecha de nacimiento correcta?
      </h4>
      <form className="f-form-birthdate" onSubmit={handleSubmit(onSubmit)}>
        <div className="f-form-date">
          <Input
            name="day"
            placeholder="Día"
            maxLength="2"
            error={errors.day}
            register={register({
              required: { value: true, message: "*Este campo es requerido" },
            })}
          />
          <Select
            name="month"
            placeholder="Mes"
            error={errors.month}
            register={register({
              required: true,
              validate: {
                required: value =>
                  value !== "none" || "*Este campo es requerido",
              },
            })}
          >
            <option hidden selected value="none">
              Mes
            </option>
            {months.map(({ month, number }) => (
              <option value={number}>{month}</option>
            ))}
          </Select>
          <Input
            name="year"
            placeholder="Año"
            maxLength="4"
            error={errors.year}
            register={register({
              required: { value: true, message: "*Este campo es requerido" },
            })}
          />
        </div>

        <div className="f-terms-container">

          {checksPolicy.map(term => {
            return(
              <div className="f-terms" key={term.idPrincipal}>
                <div>
                  <Input
                    type="checkbox"
                    name={term.idPrincipal}
                    register={register({
                      required: {
                        value: true,
                        message: "*Este campo es requerido",
                      },
                    })}
                  />
                  <a
                    className="f-terms__label"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={siteUrl + "/" + term.redireccion}
                  >
                    {term.tituloPrincipal}
                  </a>
                </div>
                {errors[term.idPrincipal] && (
                  <span className="f-error-input">{errors?.[term.idPrincipal]?.message}</span>
                )}
              </div>
            )
          })}
        </div>


        <DataPolicy />
        <div className="f-buttons-containter">
          <Button title="Cancelar" className="secondary-pink" />
          <Button title="Siguente" className="primary-pink" type="submit" />
        </div>
      </form>
    </div>
  )
}

export default SelectBirthday
